import { render, staticRenderFns } from "./pageProposal.vue?vue&type=template&id=8eee3fd6&"
import script from "./pageProposal.vue?vue&type=script&lang=js&"
export * from "./pageProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports